export const MUI_DRAWER_WIDTH = 250;
